export default __webpack_public_path__ + "static/media/independentIndexRate.d1c336bb.svg";